import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {}

const state = initialState ();

// actions

const actions = {
  async create (context, payload) {
    return await API.filmMaker.create(payload)
  },

  async get (context, payload) {
    let response = await API.filmMaker.get(payload)
    return response.film_maker
  },

  async delete (context, payload) {
    await API.filmMaker.delete(payload)
  },

  async list (context, payload) {
    let response = await API.filmMaker.list(payload)
    return response.film_makers
  },

  async update (context, payload) {
    let response = await API.filmMaker.update(payload)
    return response.film_maker
  },
};

// getters
const getters = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
